import { PagesWrapper } from "../../styles/components/PagesWrapper.styled";
import TopPageTitle from "../TopPageTitle/TopPageTitle";
import { LuExternalLink } from "react-icons/lu";
import * as styled from "../MaterialsLevel/MaterialsLevel.styled"

const additionalMaterials = [
   {id: "1", url: "https://www.canva.com/design/DAGzydDi29U/gpFv3KQj31mXuWtKc2fUtA/view?utm_content=DAGzydDi29U&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h2750bd511c", name: "Verb to be (am/is/are)"},
   {id: "2", url: "https://www.canva.com/design/DAGzy7jBwDI/pSOSOaXgLH9wZjOWEtK4CQ/view?utm_content=DAGzy7jBwDI&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=hc1ff0be4ed", name: "Subject & Object pronouns"},
   {id: "3", url: "https://www.canva.com/design/DAG0Wv-Ud5k/_tS4bAQ2Z6ao6JtsC0iO1Q/view?utm_content=DAG0Wv-Ud5k&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=he68e2189e5", name: "Possessive Adjectives"},
   
]
function AdditionalMaterials(){
  return (
    <PagesWrapper>
      <TopPageTitle value={'Додаткові матеріали'}/>
      <styled.List>
         {additionalMaterials.map((lesson) => (
            <styled.Item key={lesson.id}>
               <styled.LessonName href={lesson.url} target="_blank" rel="noreferrer">
                  {lesson.name}
                  <LuExternalLink size={16} />
               </styled.LessonName>
            </styled.Item>
         ))}
      </styled.List>
    </PagesWrapper>
  )
};

export default AdditionalMaterials;
